module.exports = __webpack_public_path__ + "img/owee-cis-2026.45afd4c9.png";